class PaginationInfinite extends HTMLElement {
  constructor() {
    super()
    this.isLoading = false
    this.loadMoreBtn = this.querySelector('.pagination-infinite__load')

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', e => {
        this.setLoading(true)
        this.loadMore()
      })
    }

    const scrollObserver = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.setLoading(true)
        this.loadMore()
      }
    })
    if (this.dataset.autoLoad == "auto") scrollObserver.observe(this)

  }

  async loadMore(page = 1, scroll = 0) {

    const collection = document.querySelector('[data-tpl="collection"]'),
          productGrid = document.querySelector(`#shopify-section-${this.dataset.sectionId} .product-grid`),
          productGridCards = document.querySelector(`#shopify-section-${this.dataset.sectionId} .product-grid__cards`);

    // if page == 0, paste html from local storage and reinit sliders
    if (page == 0) {
      
      if ( window.app.collectionHistory.getLs() != '' ) {
        let history_data = window.app.collectionHistory.stringToData(window.app.collectionHistory.getLs());

        if ( history_data.length ){
          if ( history_data[0].tpl == 'collection' && history_data[0].url == window.location.href) {
            productGrid.innerHTML = history_data[0].html;

            let all_products_cards_number = document.querySelectorAll(`#shopify-section-${this.dataset.sectionId} .product-grid__cards > li`).length;
            document.querySelector(`#shopify-section-${this.dataset.sectionId} .product-grid__head__product-count span:first-child`).innerHTML = all_products_cards_number;

            if (history_data[0].scrolled != 0) {
              window.scrollTo(0, history_data[0].scrolled);
            }
          }
        }
      }

      if (collection ) {
        collection.classList.add('is_visible');
      }

    } else {

      const params = new URLSearchParams(location.search);
    
      params.append('sections', this.dataset.sectionId);

      let current_page_number = page != 1 ? page : parseFloat(this.getAttribute('data-current-page')),
          next_page_number = current_page_number + 1;

      params.append('page', next_page_number);

      const res = await fetch(`${location.pathname}?${params}`, {
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      const section = await res.json()
      const element = document.createElement('div')
      element.innerHTML = section[this.dataset.sectionId]

      const renderedProductGridCards = element.querySelector('.main-collection .product-grid__cards');
      
      productGridCards.innerHTML += renderedProductGridCards.innerHTML
      this.setLoading(false)

      setTimeout(() => {

        let all_products_cards_number = document.querySelectorAll(`#shopify-section-${this.dataset.sectionId} .product-grid__cards > li`).length;
        this.setAttribute('data-loaded', all_products_cards_number);

        let data_loaded_span = this.querySelector('.pagination-infinite__progress-bar + span > span:first-child'),
            data_total_span = this.querySelector('.pagination-infinite__progress-bar + span > span:last-child');

        if (data_loaded_span && data_total_span) {
          data_loaded_span.innerHTML = all_products_cards_number;
          
          let data_total_span_number = parseFloat(data_total_span.innerHTML),
              one_percent = data_total_span_number / 100,
              progressbar_value = parseFloat(data_loaded_span.innerHTML) / one_percent;

          this.querySelector('.pagination-infinite__progress-bar__inner').style.width = progressbar_value+'%';

          if (all_products_cards_number == data_total_span_number) {
            this.querySelector('.btn.pagination-infinite__load').remove();
          }
        }

        this.setAttribute('data-current-page', next_page_number);

        if (collection ) {
          collection.classList.add('is_visible');
        }

        if ( scroll != 0 ) {
          window.scrollTo(0, scroll);
        }
      }, 100);

    }

  }

  setLoading(state) {
    const submitButton = document.querySelector('.submit-filters')

    if (state) {
      submitButton.disabled = true
      this.loadMoreBtn.classList.add('is-loading')
      
    } else {
      submitButton.disabled = false
      this.loadMoreBtn.classList.remove('is-loading')
    }
  }

  generateRandomString(length) {
    let counter = 0,
        result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
          charactersLength = characters.length;
    
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    return result;
  }

}

customElements.define('pagination-infinite', PaginationInfinite)
